import { render, staticRenderFns } from "./Perolas.vue?vue&type=template&id=3137dc2e&scoped=true"
import script from "./Perolas.vue?vue&type=script&lang=js"
export * from "./Perolas.vue?vue&type=script&lang=js"
import style0 from "./Perolas.vue?vue&type=style&index=0&id=3137dc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137dc2e",
  null
  
)

export default component.exports